
const allImages = [
  {
    title:'shdks',
    src: '/assets/images/school-images/1.jpg',
    category: 'Events',
  },
  {
    title:'shdks',
    src: '/assets/images/school-images/2.jpg',
    category: 'Events',
  },
  {
    title:'shdks',
    src: '/assets/images/school-images/3.jpg',
    category: 'Class',
  },  {
    title:'shdks',
    src: '/assets/images/school-images/4.jpg',
    category: 'Events',
  },  {
    title:'shdks',
    src: '/assets/images/school-images/5.jpg',
    category: 'Class',
  },  {
    title:'shdks',
    src: '/assets/images/school-images/6.jpg',
    category: 'Events',
  },  {
    title:'shdks',
    src: '/assets/images/school-images/7.jpg',
    category: 'Events',
  },  {
    title:'shdks',
    src: '/assets/images/school-images/8.jpg',
    category: 'Events',
  },  {
    title:'shdks',
    src: '/assets/images/school-images/10.jpg',
    category: 'Events',
  },  {
    title:'shdks',
    src: '/assets/images/school-images/11.jpg',
    category: 'Class',
  },  {
    title:'shdks',
    src: '/assets/images/school-images/12.jpg',
    category: 'Class',
  },  {
    title:'shdks',
    src: '/assets/images/school-images/13.jpg',
    category:'Events',
  },  {
    title:'shdks',
    src: '/assets/images/school-images/14.jpg',
    category: 'Events',
  },  {
    title:'shdks',
    src: '/assets/images/school-images/15.jpg',
    category: 'Events',
  },  {
    title:'shdks',
    src: '/assets/images/school-images/16.jpg',
    category: 'Events',
  },  {
    title:'shdks',
    src: '/assets/images/school-images/17.jpg',
    category: 'Events',
  },  {
    title:'shdks',
    src: '/assets/images/school-images/18.jpg',
    category: 'Events',
  },  {
    title:'shdks',
    src: '/assets/images/school-images/19.jpg',
    category: 'Activities',
  },  {
    title:'shdks',
    src: '/assets/images/school-images/20.jpg',
    category: 'Activities',
  },  {
    title:'shdks',
    src: '/assets/images/school-images/21.jpg',
    category: 'Activities',
  },  {
    title:'shdks',
    src: '/assets/images/school-images/22.jpg',
    category: 'Activities',
  },  {
    title:'shdks',
    src: '/assets/images/school-images/23.jpg',
    category: 'Events',
  },  {
    title:'shdks',
    src: '/assets/images/school-images/24.jpg',
    category: 'Class',
  },  {
    title:'shdks',
    src: '/assets/images/school-images/25.jpg',
    category: '',
  },  {
    title:'shdks',
    src: '/assets/images/school-images/26.jpg',
    category: 'Class',
  },  {
    title:'shdks',
    src: '/assets/images/school-images/27.jpg',
    category: 'Class',
  },  {
    title:'shdks',
    src: '/assets/images/school-images/28.jpg',
    category: 'Activities',
  },  {
    title:'shdks',
    src: '/assets/images/school-images/29.jpeg',
    category: 'Activities',
  }, {
    title:'shdks',
    src: '/assets/images/school-images/30.jpeg',
    category: 'Class',
  }, {
    title:'shdks',
    src: '/assets/images/school-images/31.jpeg',
    category: 'Activities',
  }, {
    title:'shdks',
    src: '/assets/images/school-images/32.jpeg',
    category: 'Class',
  }, {
    title:'shdks',
    src: '/assets/images/school-images/33.jpeg',
    category: 'Activities',
  }, {
    title:'shdks',
    src: '/assets/images/school-images/34.jpeg',
    category: 'Activities',
  }, {
    title:'shdks',
    src: '/assets/images/school-images/35.jpeg',
    category: 'Activities',
  }, {
    title:'shdks',
    src: '/assets/images/school-images/36.jpeg',
    category: 'Activities',
  }, {
    title:'shdks',
    src: '/assets/images/school-images/37.jpeg',
    category: 'Activities',
  }, {
    title:'shdks',
    src: '/assets/images/school-images/38.jpeg',
    category: 'Activities',
  }, {
    title:'shdks',
    src: '/assets/images/school-images/39.jpeg',
    category: 'Activities',
  }, {
    title:'shdks',
    src: '/assets/images/school-images/40.jpeg',
    category: 'Activities',
  }, {
    title:'shdks',
    src: '/assets/images/school-images/41.jpeg',
    category: 'Activities',
  }, {
    title:'shdks',
    src: '/assets/images/school-images/42.jpeg',
    category: 'Activities',
  }, {
    title:'shdks',
    src: '/assets/images/school-images/43.jpeg',
    category: 'Class',
  }, {
    title:'shdks',
    src: '/assets/images/school-images/44.jpeg',
    category: 'Activities',
  }, {
    title:'shdks',
    src: '/assets/images/school-images/45.jpeg',
    category: 'Activities',
  }, {
    title:'shdks',
    src: '/assets/images/school-images/46.jpeg',
    category: 'Class',
  }, {
    title:'shdks',
    src: '/assets/images/school-images/47.jpeg',
    category: 'Class',
  }, {
    title:'shdks',
    src: '/assets/images/school-images/48.jpeg',
    category: 'Events',
  }, {
    title:'shdks',
    src: '/assets/images/school-images/49.jpeg',
    category: 'Class',
  }, {
    title:'shdks',
    src: '/assets/images/school-images/50.jpeg',
    category: 'Events',
  }, {
    title:'shdks',
    src: '/assets/images/school-images/51.jpeg',
    category: 'Events',
  }, {
    title:'shdks',
    src: '/assets/images/school-images/52.jpeg',
    category: '',
  }, {
    title:'shdks',
    src: '/assets/images/school-images/53.jpeg',
    category: '',
  }, 
];
export default allImages
